import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { PPSRCheckDialogData, PPSRCheckDialogResult } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';


@Component({
    templateUrl: './PPSR-check.dialog.html',
    styleUrls: ['./PPSR-check.dialog.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, MatDialogModule]
})
export class PPSRCheckDialog {

  constructor(@Inject(MAT_DIALOG_DATA) public data: PPSRCheckDialogData,
              private dialogRef: MatDialogRef<PPSRCheckDialog, PPSRCheckDialogResult>) {
  }


  onSubmit($event: MouseEvent) {
    const result: PPSRCheckDialogResult = {}
    this.dialogRef.close(result);
  }

  onCancel($event: MouseEvent){
    this.dialogRef.close()
  }
}

